import React from 'react';
import { toastr } from 'react-redux-toastr';
import { Customer, Entity, LeadDemographic } from '../../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import api from '../../../../api';

import DemographicForm from './DemographicForm';

const Demographics: React.FunctionComponent<{
  customerDetails?: Customer;
  updateUser: () => void;
  canUpdateCustomerDemographics?: boolean;
  fields: { displayName: string; value: string; type: string; group: string }[];
}> = (props) => {
  const [isSaving, setSaving] = React.useState<boolean>(false);

  const onSubmit = async (data?: any) => {
    setSaving(true);
    const preferredLanguage =
      data.languagesSpeak && data.languagesSpeak.length > 0
        ? data.languagesSpeak.find(
            (x: { language: string; isPrimary: boolean }) => x.isPrimary
          )
        : props.customerDetails?.preferredLanguage;
    const languages =
      data.languagesSpeak && data.languagesSpeak.length > 0
        ? data.languagesSpeak
            .map((x: { language: string; isPrimary: boolean }) => x.language)
            ?.filter((l: string) => l !== '')
        : props.customerDetails?.languagesSpeak;

    const updateData: LeadDemographic = {};

    props?.fields?.forEach((p) => {
      if (p.value === 'tags') {
        updateData.tags = data.tag ? [data.tag] : undefined;
      } else if (p.value === 'pfNumber') {
        updateData.pfNumber =
          data?.pfNumber && data.isAlghanimEmployee
            ? Number(data?.pfNumber)
            : undefined;
      } else if (p.value === 'children') {
        updateData.children =
          data?.children?.children || props.customerDetails?.children;
        updateData.numberOfChildren =
          data?.children?.numberOfChildren ||
          props.customerDetails?.numberOfChildren;
      } else if (p.value === 'languagesSpeak') {
        updateData.languagesSpeak = languages;
        updateData.preferredLanguage = preferredLanguage?.language || undefined;
      } else if (p.value === 'gender') {
        updateData.gender = data?.gender || props.customerDetails?.gender;
      } else if (p.value === 'dob') {
        updateData.dob = data?.dob || props.customerDetails?.dob;
      } else if (p.value === 'identifiers.nationality') {
        updateData.nationality = data.nationality;
      } else {
        (updateData as any)[p.value] = data[p.value];
      }
    });

    try {
      await api.customer.updateDemographics(
        updateData,
        props.customerDetails?._id
      );
      props.updateUser();
      toastr.success('Success', 'Demographics saved successfully');
    } catch (error) {
      toastr.error('Error', error?.response?.data?.message);
    }
    setSaving(false);
  };

  return (
    <DemographicForm
      onSubmit={onSubmit}
      customerDetails={props.customerDetails}
      canUpdateCustomerDemographics={props.canUpdateCustomerDemographics}
      isSaving={isSaving}
      fields={props.fields}
    ></DemographicForm>
  );
};

export default Demographics;
